/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Submit_ButtonInputs */

const en_company_registration_submit_button = /** @type {(inputs: Company_Registration_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit`)
};

const de_company_registration_submit_button = /** @type {(inputs: Company_Registration_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschicken`)
};

/**
* | output |
* | --- |
* | "Submit" |
*
* @param {Company_Registration_Submit_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_submit_button = /** @type {((inputs?: Company_Registration_Submit_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Submit_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_submit_button(inputs)
	return en_company_registration_submit_button(inputs)
});